exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n* {\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\n}\nbody {\r\n  margin: 0;\n}\n#app {\r\n  background-color: #f5f5f5;\r\n  overflow: auto;\n}\n.group {\r\n  max-width: 1000px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n  background-color: #fff;\r\n  -webkit-box-shadow: 0 1px 15px rgba(0, 0, 0, .1);\r\n          box-shadow: 0 1px 15px rgba(0, 0, 0, .1);\n}\n.link {\r\n  color: #409eff;\n}\n.el-select {\r\n  display: block;\n}\n@media (min-width: 768px) {\n#app {\r\n    padding: 40px;\n}\n}\n#scrollArea {\r\n  min-height: 500px;\n}\r\n", ""]);

// exports
